import { ValidatorFn } from '@angular/forms';
import { ConnectionType, DataConnection, Metadata } from '../../../API';
import { DocumentNode } from 'graphql';

interface FormField {
  fieldType: 'text' | 'number' | 'radio' | 'select' | 'textarea' | 'password' | 'fileUpload' | 'checkbox';
  fieldName: string;
  validator: ValidatorFn[];
  defaultValue: any;
  label?: string;
  placeholder?: string;
  errorText?: string;
  excludeFieldInForm?: boolean;
  layout?: 'full' | 'half';
}

export interface DataSourceCard {
  key: ConnectionType;
  imgSrc: string;
  alt: string;
  title: string;
  description: string;
  connectionDetailsText: string;
  formDetails: FormField[];
  formTemplateName: string;
  graphqlQuery?: DocumentNode | string;
  graphqlQueryName?: string;
  isDisabled: boolean;
  hideTest?: boolean;
  graphqlEditQuery?: DocumentNode | string;
  graphqlEditQueryName?: string;
  graphQlTestConnectionQuery?: DocumentNode | string;
  graphQlTestConnectionQueryName?: string;
  tooltip?: string;
}

export interface TablesMetaData {
  title: string;
  data: any;
}

export interface DataConnectionObj extends DataConnection {
  metadataList: Metadata[];
  expand: boolean;
}

export interface childMetaDataObj {
  dataConnectionId: string;
  metadata: Metadata;
  orgType: string;
}

export enum PolicyType {
  S3 = 's3',
  GLUE = 'glue',
  KMS = 'kms',
}

export const PolicyTabs = [
  {
    title: 'S3 Bucket Policy',
    headerTitle: 'S3 Bucket Policy JSON',
    type: PolicyType.S3,
    key: PolicyType.S3,
  },
  {
    title: 'Glue Catalog Policy',
    headerTitle: 'Glue Catalog Policy JSON',
    type: PolicyType.GLUE,
    key: PolicyType.GLUE,
  },
  {
    title: 'KMS Decrypt Policy',
    headerTitle: 'KMS Decrypt Policy JSON',
    type: PolicyType.KMS,
    key: PolicyType.KMS,
  },
];
